module.exports = __webpack_public_path__ + "img/file.f2abad3c.svg";